import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { NotFound } from 'views'
import { LoadingIndicator } from 'components'

const OnDemandCaseBuilderIssuerView = React.lazy(
    () => import('views/OnDemandCaseBuilderIssuer/OnDemandCaseBuilderIssuer')
)
const OnDemandCardholderFeedbackView = React.lazy(
    () => import('views/OnDemandCardholderFeedback/OnDemandCardholderFeedback')
)

const OnDemandRoutes: React.FC = () => {
    return (
        <Suspense
            fallback={
                <div style={{ padding: 16 }}>
                    <LoadingIndicator />
                </div>
            }
        >
            <Switch>
                <Route
                    component={OnDemandCaseBuilderIssuerView}
                    exact
                    path="/builder"
                />
                <Route
                    component={OnDemandCardholderFeedbackView}
                    exact
                    path="/feedback"
                />
                <Route component={NotFound} exact path="/not-found" />
            </Switch>
        </Suspense>
    )
}

export default OnDemandRoutes
